export default __webpack_public_path__ + "static/visual_studio-6701751b40929a134f0964f7d354c63b.webp";